import React, { useEffect, useState } from "react";
import { useAuth } from "../../Context/AuthContext";
import { v4 as uuidv4 } from "uuid";
import {
  Alert,
  Button,
  FloatingLabel,
  Form,
  ProgressBar,
  Stack,
} from "react-bootstrap";
import * as FiIcons from "react-icons/fi";
import { ReactSpreadsheetImport } from "react-spreadsheet-import";
import ButtonRefresh from "../../components/generic/_ButtonRefresh";

import { ApiEndpoint } from "../../utils/ApiEndpoint";
import { httpClient } from "../../utils/HttpClient";
import BtnExportToExcell from "../../utils/BtnExportToExcell";
import Notification from "../../components/notification";
import PropTypes from "prop-types";
import { isEmail } from "../../utils/FormatData";
const FIELDS = [
  {
    // Visible in table header and when matching columns.
    label: "Telefono",
    // This is the key used for this field when we call onSubmit.
    key: "telefono",
    // Allows for better automatic column matching. Optional.
    alternateMatches: [
      "Phone",
      "Telefono",
      "msisdn",
      "NUMERO",
      "numero",
      "phone",
      "telefono",
    ],
    // Used when editing and validating information.
    fieldType: {
      // There are 3 types - "input" / "checkbox" / "select".
      type: "input",
    },
    // Can have multiple validations that are visible in Validation Step table.
    validations: [
      {
        // Can be "required" / "unique" / "regex"
        rule: "required",
        errorMessage: "Debe contener un numero de telefono",
        // There can be "info" / "warning" / "error" levels. Optional. Default "error".
        level: "error",
      },
    ],
  },
  {
    // Visible in table header and when matching columns.
    label: "Correo Electronico",
    // This is the key used for this field when we call onSubmit.
    key: "email",
    // Allows for better automatic column matching. Optional.
    alternateMatches: [
      "Email",
      "Correo",
      "Mail",
      "correo",
      "mail",
      "email",
      "Correo Electronico",
      "correo electronico",
    ],
    // Used when editing and validating information.
    fieldType: {
      // There are 3 types - "input" / "checkbox" / "select".
      type: "input",
    },
  },
];
const EditDbAdv = ({ handleClose }) => {
  const tmpUid = uuidv4();
  let intervalID = 0;
  let startCounting = 0;
  const [isHidden, setIsHidden] = useState(false);
  const [currentUid, setCurrentUid] = useState(tmpUid);

  const [displayMessageDb, setDisplayMessageDb] = useState(false);
  const [messageDb, setMessageDb] = useState(null);
  const [alertTypeDb, setAlertTypeDb] = useState(null);
  const [carrierList, setCarrierList] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  //const [fieldsFromFile, setFieldsFromFile] = useState(null);
  const [validated, setValidated] = useState(false);
  const [data, setData] = useState(null);
  const [isWorking, setIsWorking] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [fields, setFields] = useState(FIELDS);
  const [started, setStarted] = useState(false);
  const [dataToExport, setDataToExport] = useState(null);
  function onClose() {
    setIsOpen(false);
  }
  const Auth = useAuth();
  var userData = Auth.getSessionData();
  const [values, setValues] = useState({
    idcarrier: "0",
    name: "",
    uid_partner: "",
  });

  const clearData = () => {
    setCurrentUid(uuidv4());

    setData(null);
    setIsWorking(false);
  };
  const onChange = (event) => {
    const { name, value } = event.target;
    setValues({ ...values, [name]: value });
  };

  const handleSubmit1 = (event) => {
    setIsSaving(true);
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
    setValidated(true);
    const URICustomer = ApiEndpoint + "campaigns/addPartnerDatabase";

    httpClient(
      "POST",
      URICustomer,
      {
        partner: Auth.getSessionData().uid_partner ?? null,
        name: values.name,
        uiddatabase: currentUid,
        isHidden: isHidden,
        uid_user: Auth.getSessionData().uid_user,
        idcarrier: values.idcarrier,
      },
      userData.token
    )
      .then(function (response) {
        console.log(response.data);
        setIsSaving(false);
        if (response.data.error) {
          setAlertTypeDb("warning");
          setMessageDb(response.data.message);
          setDisplayMessageDb(true);
        } else {
          handleClose();
          return;
        }
      })
      .catch(function (error) {
        setAlertTypeDb("warning");
        setMessageDb("Ha ocurrido un error");
        setDisplayMessageDb(true);
        console.log(error);
      });
  };

  const getCarriersList = () => {
    const URICarriers = ApiEndpoint + "carrierspanel";

    httpClient("GET", URICarriers, {}, userData.token)
      .then(function (response) {
        setCarrierList(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  const GetRecords = (data) => {
    let startIndex = 0;
    let endIndex = 500;
    let countIterations = 0;
    for (let i = 0; i < data.length; i += 500) {
      let dataToSend = data.slice(startIndex, endIndex);
      handleImportData(dataToSend);
      startIndex = endIndex;
      endIndex += 500;
      countIterations++;
      if (countIterations % 2 === 0) {
        getTmpData();
      }
    }
    getTmpData();
  };
  const handleImportData = (data) => {
    //savejsondatabases
    const URICustomer = ApiEndpoint + "campaigns/savejsondatabases";

    httpClient(
      "POST",
      URICustomer,
      {
        data: data,
        headers: fields.map((field) => field.key),
        uid: currentUid,
      },
      userData.token
    )
      .then(function (response) {
        console.log(response.data);
        setIsSaving(false);
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  const delay = (ms) => new Promise((res) => setTimeout(res, ms));
  const handleImport = async (data) => {
    setIsSaving(true);
    setStarted(true);
    GetRecords(data.validData);
    await delay(5000);
    setIsWorking(false);
    getTmpDataError();
  };

  const refreshData = () => {
    getTmpData();
  };
  const getTmpData = () => {
    const URI = ApiEndpoint + "campaigns/reporttmpdatabase/" + currentUid;
    httpClient("GET", URI, {}, userData.token).then((response) => {
      setStarted(false);
      setData(response.data[0]);
      console.log(response.data[0]);
      if (response.data[0].b_finished) {
        if (startCounting < 3 && response.data[0].i_totalrows > 50000) {
          console.log("entre a startcounting");
          startCounting++;
        } else {
          console.log("pase startcounting");
          clearInterval(intervalID);
          setIsWorking(false);
          getTmpDataError();
        }
      }
    });
  };
  const getTmpDataError = () => {
    const URI =
      ApiEndpoint + "campaigns/getPartnerDatabasesTmpError/" + currentUid;

    httpClient("GET", URI, {}, userData.token).then((response) => {
      setDataToExport(response.data);
    });
  };
  useEffect(() => {
    getCarriersList();
  }, []);
  return (
    <Form noValidate validated={validated} onSubmit={handleSubmit1}>
      {Auth.isAdminRole() && (
        <>
          <FloatingLabel label="" className="mb-3">
            <Form.Check
              type="switch"
              id="isHidden"
              value={isHidden}
              label="¿Ocultar Informacion?"
              onChange={() => {
                setIsHidden(!isHidden);
              }}
              className="prevent-validation"
            />
          </FloatingLabel>
        </>
      )}
      <FloatingLabel controlId="floatingInput" label="Nombre:" className="mb-3">
        <Form.Control
          type="text"
          name="name"
          required
          value={values.name}
          onChange={(event) => {
            onChange(event);
          }}
          placeholder="Nombre:"
        />
      </FloatingLabel>
      <FloatingLabel label="Limitar a Operadora *" className="mb-3">
        <Form.Select
          id="idcarrier"
          name="idcarrier"
          onChange={(selectedOption) => {
            onChange(selectedOption);
          }}
          value={values.idcarrier}
          required
          aria-label="select_carrier"
        >
          <option value="0">Todos</option>
          {!!carrierList?.length &&
            carrierList.map((carrier) => (
              <option key={carrier.idcarrier} value={carrier.idcarrier}>
                {carrier.carrier}
              </option>
            ))}
        </Form.Select>
      </FloatingLabel>
      <Form.Group className="mb-3">
        <Form.Label>Cargar una base de datos:</Form.Label>
      </Form.Group>
      <Alert key={"secondary"} variant={"secondary"} className="Notice">
        <b>Nota:</b> La primer columna debe ser el número de teléfono, no
        importa el nombre de la columna. Tu archivo debe ser en formato{" "}
        <b>.csv</b>, puede contener campos adicionales que serán almacenados
        como datos extra.
      </Alert>
      <Button
        onClick={() => {
          setIsOpen(true);
        }}
      >
        Cargar nuevo archivo
      </Button>
      <ReactSpreadsheetImport
        isOpen={isOpen}
        onClose={onClose}
        fields={fields} // make sure this is the state
        translations={{
          uploadStep: {
            title: "Cargar Archivo",
            manifestTitle: "Debe contener al menos el siguiente campo:",
            manifestDescription: "",
            dropzone: {
              title: "Archivos Aceptados .xlsx, .xls or .csv file",
              errorToastDescription: "Archivo Rechazado",
              activeDropzoneTitle: "Arrastra el archivo aqui...",
              buttonTitle: "Seleccionar Archivo",
              loadingTitle: "Procesando...",
            },
          },
          selectHeaderStep: {
            title: "Seleccionar columnas",
            nextButtonTitle: "Siguiente",
            backButtonTitle: "Back",
          },
          matchColumnsStep: {
            title: "Confirmar Datos",
            nextButtonTitle: "Siguiente",
            backButtonTitle: "Atras",
            userTableTitle: "Tus Columnas:",
            templateTitle: "Corresponden a:",
            selectPlaceholder: "Seleccionar columnas...",
            ignoredColumnText: "Ignorar",
            matchDropdownTitle: "Corresponde a",
            unmatched: "Unmatched",
          },
          validationStep: {
            title: "Validar informacion",
            nextButtonTitle: "Confirmar",
            backButtonTitle: "Atras",
            noRowsMessage: "Sin registros",
            noRowsMessageWhenFiltered: "No data containing errors",
            discardButtonTitle: "Ingorar las filas seleccionadas",
            filterSwitchTitle: "Mostrar filas con errores",
          },
          unmatchedRequiredFields: {
            headerTitle: "Ha ocurrido un error",
            bodyText:
              "Algunas columnas requeridas no se encuentran en el archivo",
            listTitle: "Errores:",
            cancelButtonTitle: "Cancel",
            continueButtonTitle: "Continue",
          },
        }}
        onSubmit={(data) => {
          handleImport(data);
        }}
        matchColumnsStepHook={async (data, rawData, columns) => {
          const customFields = columns
            .filter((col) => !("value" in col)) // remove columns that were matched
            .map((col) => {
              return {
                label: col.header,
                key: col.header,
                fieldType: {
                  type: "input",
                },
                example: "",
              };
            });

          setFields([...fields, ...customFields]);

          return data;
        }}
        selectHeaderStepHook={async (headerValues, data) => {
          // Start with your required fields
          let updatedFields = [...FIELDS];
          // Add new columns that are not already defined
          headerValues.forEach((header) => {
            const exists = updatedFields.some(
              (f) =>
                f.key.toLowerCase() === header.toLowerCase() ||
                f.alternateMatches
                  ?.map((m) => m.toLowerCase())
                  .includes(header.toLowerCase())
            );

            if (!exists) {
              updatedFields.push({
                label: header,
                key: header,
                fieldType: { type: "input" },
                optional: true,
              });
            }
          });
          setFields(updatedFields);
          return { headerValues, data };
        }}
        rowHook={(data, addError) => {
          if (data.email && !isEmail(data.email)) {
            addError("email", {
              message: "Invalid email format",
              level: "error",
            });
          }
          return data;
        }}
      />
      {!data && started && (
        <>
          <h5>Cargando Archivo:</h5>
          <ProgressBar variant="success" animated now={75} />
        </>
      )}
      {data && started && (
        <>
          <h5>Archivo Cargado</h5>
          <ProgressBar variant="success" animated now={100} />
        </>
      )}
      {data && (
        <>
          <div className="Status">
            <Stack direction="horizontal" gap={2}>
              <h6>{isWorking ? "Procesando..." : "Detalle"}</h6>
              <div className="ms-auto">
                <FiIcons.FiRefreshCw onClick={refreshData} />
              </div>
            </Stack>
            {isWorking ? (
              <>
                {" "}
                <ProgressBar
                  variant="success"
                  animated
                  now={(data.i_unique ?? 0 / data.i_totals ?? 1) * 100}
                />
                <Stack direction="horizontal" gap={2}>
                  <div>
                    <p>{data.i_unique ?? 0}</p>
                  </div>
                  <div className="ms-auto">
                    <p>{data.i_totals ?? 0}</p>
                  </div>
                </Stack>
              </>
            ) : (
              <>
                {" "}
                <Alert
                  key={"secondary"}
                  variant={"secondary"}
                  className="Notice"
                >
                  <b>Archivo procesado</b>
                </Alert>
              </>
            )}
            <h5>Numeros Procesados:</h5>
            <Stack direction="horizontal" gap={2}>
              <div>
                <p>
                  Numeros Unicos: <b>{data.i_unique ?? 0}</b>
                </p>
              </div>
              <div className="ms-auto">
                <p>
                  Validos: <b>{data.i_valid ?? 0}</b>
                </p>
              </div>
            </Stack>{" "}
            <Stack direction="horizontal" gap={2}>
              <div>
                <p>
                  Fallidos: <b>{data.i_totals - data.i_valid ?? 0}</b>
                </p>
              </div>
              <div className="ms-auto">
                <p>
                  Total: <b>{data.i_totals ?? 0}</b>
                </p>
              </div>
            </Stack>
          </div>
        </>
      )}
      {dataToExport && (
        <BtnExportToExcell
          dataReport={dataToExport}
          fileName="Error_Report"
          label={"Exportar Fallidos"}
        ></BtnExportToExcell>
      )}
      <hr />
      <div className="text-right">
        {data && !isWorking && (
          <>
            <Button
              variant="primary"
              type="button"
              className="align-self-end"
              onClick={() => clearData()}
            >
              Limpiar
            </Button>
            {data.i_valid > 0 && (
              /* <Button
                    variant="primary"
                    type="submit"
                    className="align-self-end"
                  >
                    Guardar
                  </Button>*/
              <ButtonRefresh
                refreshFunction={() => {}}
                loading={isSaving}
                legendButton="Guardar"
                typeButton="submit"
              ></ButtonRefresh>
            )}
          </>
        )}
      </div>
      {/* {itemsProcessed && (
            <>
              <ListDatabase
                dataitems={itemsProcessed}
                fieldsFromFile={fieldsFromFile}
                invalidItemsCount={invalidItems}
                invalidItems={invalidItemsProcessed}
              />
            </>
          )}   */}
      {displayMessageDb && (
        <Notification
          show={displayMessageDb}
          setShow={setDisplayMessageDb}
          message={messageDb}
          alertType={alertTypeDb}
        />
      )}
    </Form>
  );
};
EditDbAdv.propTypes = {
  handleClose: PropTypes.func.isRequired,
};
export default EditDbAdv;
